/**
 * @file FooterSection.jsx
 * @author Rishikesh
 * @date 2024-09-18
 * @description Footer section on the Master settings.
 */
import { Button, Skeleton, Stack } from "@mui/material";
import React from "react";

export const FooterSection = ({ isLoading, handleSave }) => {
  return (
    <Stack
      width="100%"
      mt={2}
      direction="row"
      alignItems="center"
      justifyContent="end"
      spacing={2}
    >
      {isLoading ? (
        <Skeleton variant="rounded" width={160} height={40} />
      ) : (
        <Button
          onClick={handleSave}
          variant="contained"
          sx={{ borderRadius: "12px", minWidth: 160, py: 1.2 }}
        >
          Save
        </Button>
      )}
    </Stack>
  );
};
